function SbusSearch(pmsg,pvadult,pvchild,pto){
	
	var msg = pmsg;
	var now = new Date();
	var vadult = pvadult;
	var vchild = pvchild;
	var to = pto;
	
	$.single = $.single || function(a){return function(b){a[0]=b;return a}}($([0]));
	var rates = rates || false;
	var ratesCalled = false;
	
	var getRates = function(obj, eventType) {
		if (!(rates || ratesCalled)) {
			ratesCalled = true;
			$.ajax({
				async : false,
				url : "/currencyRates",
				dataType : "json",
				success : function(data) {
					rates = data;
					$(obj)[eventType]();
				}
			});
		}

		return rates;
	};
	
	this.init = function(){

		$("#frmSearch").validate({
			meta : "validate",
			errorPlacement: function(error, element) {
			}
		});
		
		$("#frmSearch").on('submit',function(){
			if($("#frmSearch").valid()){
				openLoaderBox();
			}
		});
		
		$('#from').on('change',function(){
			var departureId = $(this).val();
			if(departureId.length > 0){
				$.ajax({
					type : 'POST',
					url : '/sbus/arrivals',
					dataType : 'JSON',
					data : {
						departureId : departureId
					}
				}).done(function(arrivals){
					var options = '<option value="">---</option>';
					$.each(arrivals,function(idx,item){
						options += '<option value="' + item.id + '">' + item.name + '</option>';
					});
					$('#to').html(options);
					$('#to option[value="'+to+'"]').prop('selected',true);
				});
			}
		}).trigger('change');
		
		var $toDate = $("[name=toDate]");
		var $fromDate = $("[name=fromDate]");
		
		$.validator.addMethod("vehicle", function(value, element) { 
	  		return $('#withVehicle').val() == 'false' || $(element).val() != '' || parseInt($(element).val()) > 0;
		}, "");
		
		$('.datepicker').datepicker({
			yearRange:"0:+1",
			numberOfMonths : 1,
			dateFormat : 'dd/mm/yy',
			firstDay : 1,
			minDate: now,
			beforeShow : function(input, inst){
				if($toDate.is(input)){
					inst.settings.minDate = $fromDate.val()
				}
			},
			onSelect: function(dataText, inst){
				if($fromDate.is(inst.input)){
					var fromDate = $fromDate.datepicker("getDate");
					var toDate = $toDate.datepicker("getDate");
					if(toDate && fromDate.getTime()>=toDate.getTime()){
						toDate.setTime(fromDate.getTime());
						toDate.setDate(toDate.getDate()+4);
						$toDate.datepicker("setDate", toDate);					
					}
				}
			}
		});
		
		$('.datepicker').attr('readonly','readonly'); 
		
		$('#returnDateClick').click(function(){
			$("#dtReturn").removeAttr("disabled");
			$("#dtReturn").datepicker('show');
			$("#clrReturnDate").show();
			$("#hasReturnDate").val("true");
		});
		
		$('#clrReturnDate').click(function(){
			$("#dtReturn").attr('disabled','disabled');
			$("#clrReturnDate").hide();
			$("#hasReturnDate").val("false");
		});
		
		$('input[name="sbusVehicle"]').change(function(){
		    if ($('input[name="sbusVehicle"]:checked').val() == 0) {
		       $('.withoutVehicle').show();
		       $('.withVehicle').hide();
		       $('#v-true').hide();
		       $('#v-false').show();
		       $("#adultCount, #childCount, #pressCount, #disabilityCount, #veteranCount, #studentCount, #elderlyCount").trigger('change');
		    } else {
		    	$('.withoutVehicle').hide();
			    $('.withVehicle').show();
			    $('#v-true').show();
			    $('#v-false').hide();
			    $("#vadultCount, #vchildCount").trigger('change');
		    }
		}).trigger('change');
		
		$('#vehicleType, #vehicleCount').on('change',function(){
			var max = parseInt($('#vehicleType').find('option:selected').data('max'));
			var vehicleCount = parseInt($('#vehicleCount').val());
			var options = '<option value="0">0</option>';
			for(i = 1;i <= max*vehicleCount;i++){
				options += '<option value="' + i + '">' + i + '</option>';
			}
			$('#vadultCount').html(options);
			$('#vchildCount').html(options);
		}).trigger('change');
		
		$('#vadultCount option[value="'+vadult+'"]').prop('selected',true);
		$('#vchildCount option[value="'+vchild+'"]').prop('selected',true);
		
		$('#prevdays').on('click',function(){
			var date = $('#dtDep').datepicker('getDate');
	        date.setDate(date.getDate() - 1)
	        $('#dtDep').datepicker("setDate", date);
	        $('#frmSearch').submit();
		});
		
		$('#nextdays').on('click',function(){
			var rdate = $('#dtReturn').datepicker('getDate');
			var date = $('#dtDep').datepicker('getDate');
	        date.setDate(date.getDate() + 1);
	        if(rdate >= date || $('#prevdaysReturn').length == 0){
		        $('#dtDep').datepicker("setDate", date);
		        $('#frmSearch').submit();
	        }
		});
		
		$('#prevdaysReturn').on('click',function(){
			var ddate = $('#dtDep').datepicker('getDate');
			var date = $('#dtReturn').datepicker('getDate');
	        date.setDate(date.getDate() - 1);
			if(date >= ddate){
		        $('#dtReturn').datepicker("setDate", date);
		        $('#frmSearch').submit();
			}
		});
		
		$('#nextdaysReturn').on('click',function(){
			var date = $('#dtReturn').datepicker('getDate');
	        date.setDate(date.getDate() + 1);
	        $('#dtReturn').datepicker("setDate", date);
	        $('#frmSearch').submit();
		});
		
		$('#rates').on('change',function(event) {
			var rates = getRates(this, event.type);
			if(!rates)
				return;
			
			var currency = this.value;
			
			var toCurrencies = rates[currency];
			
			$('span.money').each(function() {
				var amount = $.single(this).attr('amount');
				var fromCurrency = $.single(this).attr('currency');
				
				var rate = toCurrencies[fromCurrency];
				var rvalue = (amount * rate).toFixed(2);
				
				$.single(this).html(rvalue);
			});
			
			$('span.currency').each(function() {
				$.single(this).html(currency);
			});
		});
		
		$('#btnSubmit').on('click',function(){
			if($('input[name="departureFareOptionKey"]:checked').length == 0){
				alert(msg.selectFare);
			} else {
				$('input[type="hidden"][name="departureFareOptionKey"]').val($('input[name="departureFareOptionKey"]:checked').val());
				$('#mainForm').submit();
			}
		});
		
		$('.btn-price').on('click',function(){
			$('input[type="hidden"][name="departureFareOptionKey"]').val($.single(this).attr('data-key'));
			$('#mainForm').submit();
		});
		
		
	};
};